<p class="clearfix mb-0 text-center">
  <span class="d-block d-md-inline-block mt-25">
    &copy; {{ year }} <strong>{{ coreConfig.app.appRumahSakit }}</strong>
    <span class="d-none d-sm-inline-block"> &mdash; {{ coreConfig.app.appVendor }}</span>
  </span>
</p>

<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>
